import { render, staticRenderFns } from "./receMxReport.vue?vue&type=template&id=c55cfbec&scoped=true"
import script from "./receMxReport.vue?vue&type=script&lang=js"
export * from "./receMxReport.vue?vue&type=script&lang=js"
import style0 from "./receMxReport.vue?vue&type=style&index=0&id=c55cfbec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55cfbec",
  null
  
)

export default component.exports